var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var CollectionHeader = function (props) {
    var description = props.description, articles = props.articles, authors = props.authors, title = props.title;
    return (_jsxs("header", __assign({ className: "collection-header" }, { children: [_jsx("h2", __assign({ className: "title" }, { children: title })), description && _jsx("p", __assign({ className: "desc" }, { children: description })), _jsxs("div", __assign({ className: "author" }, { children: [_jsxs("p", { children: [articles.length, " article", articles.length > 1 && "s", " ", _jsx("br", {}), "By ", authors[0].name, " ", authors.length > 1 &&
                                "and ".concat(authors.length == 2
                                    ? authors[1].name
                                    : "".concat(authors.length - 1, " others"))] }), _jsx("div", __assign({ className: "authors" }, { children: authors.map(function (author) {
                            return (_jsx("div", __assign({ className: "img-frame" }, { children: _jsx("div", __assign({ className: "img-container" }, { children: _jsx("img", { src: author.profile_img_url }) })) })));
                        }) }))] }))] })));
};
export default CollectionHeader;
